(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelier-product"] && !Shopify.designMode) return;
  try {
    
function mountDeliveryNotes(root){
  const notes=root.querySelectorAll('.cav-delivery:not([data-delivery-ready])');
  notes.forEach(note=>{
    note.dataset.deliveryReady='true';
    if(!('IntersectionObserver' in window))return;
    const observer=new IntersectionObserver(entries=>{
      entries.forEach(entry=>{entry.target.classList.toggle('is-in-view',entry.isIntersecting);if(entry.isIntersecting){entry.target.classList.add('is-arrived');}});
    },{threshold:.5});
    observer.observe(note);
  });
}
mountDeliveryNotes(document);
document.addEventListener('shopify:section:load',event=>mountDeliveryNotes(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cavador-before-after"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(el){
    if(el.dataset.cavReady)return;
    var input=el.querySelector('.cav-ba__range'),control=el.querySelector('.cav-ba__control'),stage=el.querySelector('.cav-ba__frames');
    if(!input||!control||!stage)return;
    el.dataset.cavReady='1';
    var bl=el.dataset.bl||'Before',al=el.dataset.al||'After',drag=false;
    function set(v){v=Math.max(0,Math.min(100,Math.round(v)));if(String(v)!==input.value)input.value=v;el.style.setProperty('--cav-pos',v+'%');input.setAttribute('aria-valuetext',bl+' '+v+'%, '+al+' '+(100-v)+'%');}
    function pos(e){var r=stage.getBoundingClientRect();return r.width?(e.clientX-r.left)/r.width*100:+input.value;}
    input.addEventListener('input',function(){set(+input.value);});
    stage.addEventListener('pointerdown',function(e){if(e.pointerType==='mouse'&&e.button!==0)return;drag=true;try{stage.setPointerCapture(e.pointerId);}catch(x){}if(e.pointerType==='mouse')set(pos(e));});
    stage.addEventListener('pointermove',function(e){if(drag)set(pos(e));});
    ['pointerup','pointercancel','lostpointercapture'].forEach(function(t){stage.addEventListener(t,function(){drag=false;});});
    control.hidden=false;el.classList.add('is-enhanced');set(+input.value);
  }
  function all(root){(root||document).querySelectorAll('[data-cav-ba]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){all();});else all();
  document.addEventListener('shopify:section:load',function(e){all(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cavador-client-hub"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cavador-client-room')) {
    class CavadorClientRoom extends HTMLElement {
      connectedCallback() {
        this.releaseRoom();
        this.controller = new AbortController();
        const generation = this.generation;
        const options = { signal: this.controller.signal };
        const poster = this.querySelector('.cch__room-poster');
        this.removeAttribute('data-poster-failed');
        if (poster) {
          poster.addEventListener('error', () => this.setAttribute('data-poster-failed', ''), options);
          poster.addEventListener('load', () => this.removeAttribute('data-poster-failed'), options);
          if (poster.complete && !poster.naturalWidth) this.setAttribute('data-poster-failed', '');
        }
        const video = this.querySelector('video');
        this.video = video;
        this.visible = false;
        this.failed = false;
        this.playPending = false;
        if (!video) return;
        video.muted = true;
        video.playsInline = true;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.motion.addEventListener('change', () => this.syncPlayback(), options);
        document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
        video.addEventListener('playing', () => {
          if (this.shouldPlay()) this.setAttribute('data-playing', '');
          else this.syncPlayback();
        }, options);
        video.addEventListener('pause', () => this.removeAttribute('data-playing'), options);
        video.addEventListener('error', () => {
          this.failed = true;
          this.syncPlayback();
        }, options);
        if (typeof IntersectionObserver !== 'function') return;
        this.observer = new IntersectionObserver(entries => {
          if (generation !== this.generation || !this.isConnected) return;
          this.visible = entries.some(entry => entry.target === this && entry.isIntersecting && entry.intersectionRatio > 0);
          this.syncPlayback();
        }, { threshold: .01 });
        this.observer.observe(this);
      }
      disconnectedCallback() { this.releaseRoom(); }
      releaseRoom() {
        this.generation = (this.generation || 0) + 1;
        this.controller?.abort();
        this.observer?.disconnect();
        this.video?.pause();
        this.removeAttribute('data-playing');
        this.video = null;
        this.playPending = false;
        this.playAttempt = null;
      }
      shouldPlay() {
        return Boolean(this.isConnected && this.video && this.visible && !document.hidden && !this.motion.matches && !this.failed);
      }
      syncPlayback() {
        const video = this.video;
        if (!video) return;
        if (!this.shouldPlay()) {
          if (this.playAttempt) this.playAttempt.interrupted = true;
          this.removeAttribute('data-playing');
          video.pause();
          return;
        }
        if (!video.paused || this.playPending) return;
        const generation = this.generation;
        const attempt = { interrupted: false };
        this.playAttempt = attempt;
        this.playPending = true;
        let retryInterrupted = false;
        try {
          Promise.resolve(video.play()).then(() => {
            if (video !== this.video || !this.shouldPlay()) video.pause();
            else if (attempt.interrupted && video.paused) retryInterrupted = true;
          }).catch(error => {
            if (generation === this.generation && video === this.video) {
              this.removeAttribute('data-playing');
              retryInterrupted = attempt.interrupted && error?.name === 'AbortError';
            }
          }).finally(() => {
            if (generation === this.generation && video === this.video && this.playAttempt === attempt) {
              this.playPending = false;
              this.playAttempt = null;
              if (retryInterrupted && this.shouldPlay()) this.syncPlayback();
            }
          });
        } catch {
          this.playPending = false;
          this.playAttempt = null;
          this.removeAttribute('data-playing');
        }
      }
    }
    customElements.define('cavador-client-room', CavadorClientRoom);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cavador-client-planning"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cavador-client-project-action')) {
    class CavadorClientProjectAction extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.addEventListener('click', event => {
          const link = event.target instanceof Element ? event.target.closest('[data-cavador-project-open]') : null;
          if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const project = document.querySelector('cavador-flooring-projects[data-global-project="true"]') || document.querySelector('cavador-flooring-projects');
          const trigger = project?.querySelector('[ref="openButton"]');
          const dialog = project?.querySelector('dialog');
          if (!(trigger instanceof HTMLButtonElement) || trigger.hidden || !(dialog instanceof HTMLDialogElement)) return;
          document.dispatchEvent(new CustomEvent('cavador:project-review'));
          if (dialog.open) event.preventDefault();
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    }
    customElements.define('cavador-client-project-action', CavadorClientProjectAction);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cavador-client-rewards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cavador-reward-claim')) {
    class CavadorRewardClaim extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const form = this.querySelector('form');
        if (!form) return;
        const options = { signal: this.controller.signal };
        form.querySelectorAll('[data-reward-link]').forEach(input => {
          input.addEventListener('input', () => input.setCustomValidity(''), options);
          input.addEventListener('blur', () => this.normalizeLink(input), options);
        });
        form.addEventListener('submit', event => {
          form.querySelectorAll('[data-reward-link]').forEach(input => this.normalizeLink(input));
          if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); }
        }, options);
      }
      disconnectedCallback() { this.controller?.abort(); }
      normalizeLink(input) {
        const value = input.value.trim();
        input.setCustomValidity('');
        input.value = value;
        if (!value) return;
        try {
          const candidate = value.startsWith('//') ? 'https:' + value : /^[a-z][a-z\d+.-]*:\/\//i.test(value) ? value : 'https://' + value;
          const url = new URL(candidate);
          if (!['http:', 'https:'].includes(url.protocol) || !url.hostname.includes('.') || url.username || url.password) throw new Error('invalid');
          input.value = url.href;
        } catch { input.setCustomValidity(this.dataset.linkError || ''); }
      }
    }
    customElements.define('cavador-reward-claim', CavadorRewardClaim);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cavador-flooring-hub"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cavador-flooring-hub')) {
    customElements.define('cavador-flooring-hub', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.abort = new AbortController();
        this.grid = this.querySelector('[data-grid]');
        this.cards = Array.from(this.querySelectorAll('[data-card]'));
        this.search = this.querySelector('[data-search]');
        this.material = this.querySelector('select[data-material]');
        this.series = this.querySelector('select[data-series]');
        this.colour = this.querySelector('select[data-colour]');
        this.sort = this.querySelector('select[data-sort]');
        this.size = this.querySelector('select[data-size]');
        this.thickness = this.querySelector('select[data-thickness]');
        this.activeFilters = this.querySelector('[data-active-filters]');
        this.colourPanel = this.querySelector('[data-colour-panel]');
        this.count = this.querySelector('[data-count]');
        this.empty = this.querySelector('[data-empty]');
        this.loadArea = this.querySelector('[data-load-area]');
        this.loadButton = this.querySelector('[data-load]');
        this.showing = this.querySelector('[data-showing]');
        this.colourChoices = this.querySelector('[data-colour-choices]');
        this.colourEmpty = this.querySelector('[data-colour-empty]');
        if (!this.grid || !this.search) return;
        this.limit = 24;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.collator = new Intl.Collator(this.dataset.locale || 'en', { numeric: true, sensitivity: 'base' });
        this.seriesAllLabel = this.series.options[0].textContent;
        this.colourAllLabel = this.colour.options[0].textContent;
        this.sizeAllLabel = this.size.options[0].textContent;
        this.thicknessAllLabel = this.thickness.options[0].textContent;
        this.materialLabels = new Map(Array.from(this.material.options).map(option => [option.value, option.textContent]));
        this.normalise = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
        this.dimensionLabel = value => String(value || '').replace(/\s*[x×*]\s*/gi, ' × ').replace(/\s*mm(?=\s*(?:\(|$))/gi, ' mm').replace(/^RL up to /i, this.dataset.randomLengthLabel + ' ').replace(/\s+/g, ' ').trim();
        this.records = this.cards.map((card, index) => {
          const colour = this.normaliseColour(card.dataset.colour, card.dataset.colourLabel);
          card.dataset.colour = colour.value;
          card.dataset.colourLabel = colour.label;
          const faceDimensions = String(card.dataset.dimensions || '').replace(/\([^)]*\)/g, '');
          const sizeLabel = this.dimensionLabel(faceDimensions);
          const cardDimensions = card.querySelector('[data-card-dimensions]');
          if (cardDimensions) cardDimensions.textContent = this.dimensionLabel(card.dataset.dimensions);
          const size = this.normalise(faceDimensions).replace(/[×*]/g, 'x').replace(/\s+/g, '');
          const dimensionParts = String(card.dataset.dimensions || '').split(/[x×*]/i);
          const totalThickness = dimensionParts.length >= 3 ? parseFloat(dimensionParts[2]) : parseFloat(card.dataset.thickness);
          return {
            size, sizeLabel, card, index, title: card.dataset.title || '', material: card.dataset.material || '',
            series: card.dataset.series || '', seriesLabel: card.dataset.seriesLabel || '',
            colour: colour.value, colourLabel: colour.label,
            image: card.querySelector('.cfh__card-image img')?.getAttribute('src') || '',
            thickness: totalThickness,
            search: this.normalise([card.dataset.title, card.dataset.model, String(card.dataset.model || '').replace(/[\s_-]/g, ''), card.dataset.seriesLabel, colour.label, card.dataset.material, card.dataset.dimensions, size, card.dataset.thickness].join(' '))
          };
        });
        const materials = Array.from(new Set(this.records.map(record => record.material).filter(Boolean)));
        this.defaultMaterial = materials.length === 1 ? materials[0] : '';
        const seriesValues = Array.from(new Set(this.records.map(record => record.series).filter(Boolean)));
        this.defaultSeries = this.dataset.scope !== 'all-flooring' && seriesValues.length === 1 ? seriesValues[0] : '';
        if (this.defaultMaterial) this.material.closest('.cfh__field').hidden = true;
        if (this.dataset.scope === 'all-flooring') {
          this.querySelectorAll('[data-material-count]').forEach(element => {
            element.textContent = this.records.filter(record => record.material === element.dataset.materialCount).length;
          });
        }
        this.restore();
        this.updateOptions();
        this.bind();
        this.classList.add('is-ready');
        if (!this.reduceMotion.matches && 'IntersectionObserver' in window) {
          this.classList.add('cfh--motion');
          this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-revealed');
                this.observer.unobserve(entry.target);
              }
            });
          }, { rootMargin: '80px', threshold: 0.04 });
        }
        this.apply(false);
        this.setupFilterPanel();
        this.setupStudioComparison();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.studioComparisonAnimations?.forEach(animation => animation.cancel());
        this.initialized = false;
        if (this.frame) cancelAnimationFrame(this.frame);
        clearTimeout(this.searchTimer);
      }
      setupStudioComparison() {
        const studio = this.querySelector('.cfh__studio');
        const after = studio?.querySelector('.cfh__studio-after');
        const divider = studio?.querySelector('.cfh__studio-divider');
        const images = Array.from(studio?.querySelectorAll('.cfh__studio-comparison img') || []);
        if (!after || !divider || typeof after.animate !== 'function') return;
        this.studioComparisonAnimations = [];
        const play = () => {
          if (this.reduceMotion.matches || images.some(image => !image.complete || !image.naturalWidth)) return;
          this.studioComparisonAnimations.forEach(animation => animation.cancel());
          const options = { duration: 4600, easing: 'ease-in-out', iterations: 1 };
          const positions = [{ percent: 50, offset: 0 }, { percent: 25, offset: .3 }, { percent: 75, offset: .72 }, { percent: 50, offset: 1 }];
          this.studioComparisonAnimations = [
            after.animate(positions.map(position => ({ clipPath: `inset(0 0 0 ${position.percent}%)`, offset: position.offset })), options),
            divider.animate(positions.map(position => ({ left: `${position.percent}%`, offset: position.offset })), options)
          ];
        };
        studio.addEventListener('pointerenter', play, { signal: this.abort.signal });
        studio.addEventListener('focusin', event => { if (!studio.contains(event.relatedTarget)) play(); }, { signal: this.abort.signal });
        images.forEach(image => image.addEventListener('load', play, { once: true, signal: this.abort.signal }));
        this.reduceMotion.addEventListener('change', () => { if (this.reduceMotion.matches) this.studioComparisonAnimations.forEach(animation => animation.cancel()); }, { signal: this.abort.signal });
        play();
      }
      normaliseColour(value, label) {
        const isModelCode = text => /^TF[A-Z]*\d+[A-Z0-9]*$/i.test(String(text || '').replace(/[\s_-]/g, ''));
        if (isModelCode(value) || isModelCode(label)) return { value: '', label: '' };
        return {
          value: this.normalise(value).replace(/\bbiege\b/g, 'beige'),
          label: String(label || '').trim().replace(/\bbiege\b/gi, 'Beige')
        };
      }
      restoredLimit(raw) {
        const maximum = Math.max(24, this.cards.length);
        if (!/^\d+$/.test(raw || '')) return 24;
        const value = Number(raw);
        return Number.isSafeInteger(value) ? Math.max(24, Math.min(maximum, value)) : 24;
      }
      rememberCollection() {
        try {
          const url = new URL(window.location.href);
          if (!/^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/collections\/[^/]+\/?$/i.test(url.pathname)) return;
          url.hash = '';
          sessionStorage.setItem('cavador:browse-collection', url.href);
        } catch {}
      }
      restore() {
        const params = new URL(window.location.href).searchParams;
        this.limit = this.restoredLimit(params.get('cfh_limit'));
        this.material.value = this.defaultMaterial;
        this.series.value = ''; this.colour.value = ''; this.size.value = ''; this.thickness.value = ''; this.sort.value = 'featured';
        this.search.value = params.get('cfh_q') || '';
        const material = this.defaultMaterial || params.get('cfh_material') || '';
        if (Array.from(this.material.options).some(option => option.value === material)) this.material.value = material;
        this.restoredSeries = params.get('cfh_series') || this.defaultSeries;
        this.restoredColour = (params.get('cfh_colour') || '').replace(/\bbiege\b/gi, 'beige');
        this.restoredSize = params.get('cfh_size') || '';
        this.restoredThickness = params.get('cfh_thickness') || ''; 
        const sort = params.get('cfh_sort') || 'featured';
        if (Array.from(this.sort.options).some(option => option.value === sort)) this.sort.value = sort;
      }
      updateOptions() {
        const materialRecords = this.records.filter(record => !this.material.value || record.material === this.material.value);
        const rebuild = (select, records, key, labelKey, allLabel, restored) => {
          const previous = restored || select.value;
          const values = new Map();
          records.forEach(record => { if (record[key]) values.set(record[key], record[labelKey] || record[key]); });
          select.replaceChildren(new Option(allLabel, ''));
          Array.from(values.entries()).sort((a,b) => this.collator.compare(a[1], b[1])).forEach(([value,label]) => select.add(new Option(label, value)));
          if (values.has(previous)) select.value = previous;
        };
        rebuild(this.series, materialRecords, 'series', 'seriesLabel', this.seriesAllLabel, this.restoredSeries);
        const collectionRecords = materialRecords.filter(record => !this.series.value || record.series === this.series.value);
        rebuild(this.colour, collectionRecords, 'colour', 'colourLabel', this.colourAllLabel, this.restoredColour);
        const colourRecords = collectionRecords.filter(record => !this.colour.value || record.colour === this.colour.value);
        rebuild(this.size, colourRecords, 'size', 'sizeLabel', this.sizeAllLabel, this.restoredSize);
        const sizeRecords = colourRecords.filter(record => !this.size.value || record.size === this.size.value);
        const thicknessRecords = sizeRecords.filter(record => Number.isFinite(record.thickness)).map(record => ({ thicknessKey: String(record.thickness), thicknessLabel: record.thickness + ' mm' }));
        rebuild(this.thickness, thicknessRecords, 'thicknessKey', 'thicknessLabel', this.thicknessAllLabel, this.restoredThickness);
        this.size.disabled = this.size.options.length < 2;
        this.thickness.disabled = this.thickness.options.length < 2;
        this.restoredSeries = ''; this.restoredColour = ''; this.restoredSize = ''; this.restoredThickness = '';
        this.renderChoices(collectionRecords);
      }
      finishCount(count) {
        return (count === 1 ? this.dataset.countOneTemplate : this.dataset.countTemplate).replace('__COUNT__', count);
      }
      choiceImage(record, container) {
        const image = document.createElement('img');
        const source = new URL(record.image, window.location.href);
        if (source.hostname === 'cdn.shopify.com' || source.pathname.startsWith('/cdn/shop/')) source.searchParams.set('width', '320');
        image.src = source.href;
        image.alt = '';
        image.width = 160;
        image.height = 160;
        image.loading = 'lazy';
        image.decoding = 'async';
        image.className = 'cfh__choice-image';
        container.append(image);
      }
      choiceText(className, text) {
        const span = document.createElement('span');
        span.className = className;
        span.textContent = text;
        return span;
      }
      renderChoices(collectionRecords) {
        const focusedColour = this.colourChoices.querySelector(':focus')?.dataset.colourChoice;
        this.colourPanel.hidden = !this.series.value;
        const colours = new Map();
        collectionRecords.forEach(record => {
          if (!record.colour) return;
          if (!colours.has(record.colour)) colours.set(record.colour, []);
          colours.get(record.colour).push(record);
        });
        const colourFragment = document.createDocumentFragment();
        Array.from(colours.entries()).sort((a,b) => this.collator.compare(a[1][0].colourLabel, b[1][0].colourLabel)).forEach(([value, records]) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'cfh__colour-choice';
          button.dataset.colourChoice = value;
          button.setAttribute('aria-pressed', String(this.colour.value === value));
          const image = document.createElement('span');
          image.className = 'cfh__colour-image';
          const example = records.find(record => record.image);
          if (example) this.choiceImage(example, image);
          else image.append(this.choiceText('cfh__choice-no-image', this.dataset.noImageLabel));
          const copy = document.createElement('span');
          copy.className = 'cfh__colour-copy';
          copy.append(this.choiceText('cfh__colour-name', records[0].colourLabel || value));
          copy.append(this.choiceText('cfh__choice-count', this.finishCount(records.length)));
          button.append(image, copy);
          colourFragment.append(button);
        });
        this.colourChoices.replaceChildren(colourFragment);
        this.colourChoices.hidden = colours.size === 0;
        this.colourEmpty.hidden = colours.size > 0;
        if (focusedColour) Array.from(this.colourChoices.children).find(button => button.dataset.colourChoice === focusedColour)?.focus({ preventScroll: true });
      }
      bind() {
        const options = { signal: this.abort.signal };
        this.querySelector('[data-filter-form]').addEventListener('submit', event => event.preventDefault(), options);
        this.search.addEventListener('input', () => {
          clearTimeout(this.searchTimer);
          this.searchTimer = setTimeout(() => { this.limit = 24; this.apply(); }, 160);
        }, options);
        this.material.addEventListener('change', () => { this.series.value = ''; this.colour.value = ''; this.size.value = ''; this.thickness.value = ''; this.updateOptions(); this.limit = 24; this.apply(); }, options);
        this.series.addEventListener('change', () => {
          if (this.series.value && !this.defaultMaterial) this.material.value = this.records.find(record => record.series === this.series.value)?.material || '';
          this.colour.value = ''; this.size.value = ''; this.thickness.value = ''; this.updateOptions(); this.limit = 24; this.apply();
        }, options);
        [this.colour, this.size].forEach(select => select.addEventListener('change', () => { this.updateOptions(); this.limit = 24; this.apply(); }, options));
        [this.thickness, this.sort].forEach(select => select.addEventListener('change', () => { this.limit = 24; this.apply(); }, options));
        this.colourChoices.addEventListener('click', event => {
          const button = event.target.closest('[data-colour-choice]');
          if (!button) return;
          this.colour.value = this.colour.value === button.dataset.colourChoice ? '' : button.dataset.colourChoice;
          this.updateOptions(); this.limit = 24; this.apply();
        }, options);
        this.querySelectorAll('[data-clear]').forEach(button => button.addEventListener('click', () => {
          this.search.value = ''; this.material.value = this.defaultMaterial; this.series.value = this.defaultSeries; this.colour.value = ''; this.size.value = ''; this.thickness.value = ''; this.sort.value = 'featured'; this.limit = 24;
          this.updateOptions(); this.apply(); this.search.focus({ preventScroll: true });
        }, options));
        this.querySelectorAll('[data-material-choice]').forEach(button => button.addEventListener('click', event => {
          if (this.dataset.scope !== 'all-flooring' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.material.value = button.dataset.materialChoice;
          this.series.value = ''; this.colour.value = ''; this.size.value = ''; this.thickness.value = ''; this.limit = 24;
          this.updateOptions(); this.apply();
        }, options));
        this.activeFilters.addEventListener('click', event => {
          const button = event.target.closest('[data-remove-filter]');
          if (!button) return;
          this[button.dataset.removeFilter].value = button.dataset.removeFilter === 'material' ? this.defaultMaterial : button.dataset.removeFilter === 'sort' ? 'featured' : '';
          if (button.dataset.removeFilter === 'material') { this.series.value = ''; this.colour.value = ''; }
          if (button.dataset.removeFilter === 'series') this.colour.value = '';
          this.updateOptions(); this.limit = 24; this.apply();
          (this.activeFilters.querySelector('button') || this.search).focus({ preventScroll: true });
        }, options);
        this.loadButton.addEventListener('click', () => { this.limit = Math.min(this.limit + 24, Math.max(24, this.cards.length)); this.apply(); }, options);
        window.addEventListener('popstate', () => { this.restore(); this.updateOptions(); this.apply(false); }, options);
        window.addEventListener('pageshow', event => { if (event.persisted) { this.restore(); this.updateOptions(); this.apply(false); } }, options);
      }
      apply(updateUrl = true) {
        const words = this.normalise(this.search.value).replace(/[×*]/g, 'x').split(/\s+/).filter(Boolean);
        const matches = this.records.filter(record =>
          (!this.material.value || record.material === this.material.value) &&
          (!this.series.value || record.series === this.series.value) &&
          (!this.colour.value || record.colour === this.colour.value) &&
          (!this.size.value || record.size === this.size.value) &&
          (!this.thickness.value || String(record.thickness) === this.thickness.value) &&
          words.every(word => record.search.includes(word))
        );
        const sort = this.sort.value;
        matches.sort((a,b) => {
          if (sort === 'title-ascending') return this.collator.compare(a.title, b.title);
          if (sort === 'title-descending') return this.collator.compare(b.title, a.title);
          if (sort.startsWith('thickness-')) {
            const aValid = Number.isFinite(a.thickness), bValid = Number.isFinite(b.thickness);
            if (!aValid) return bValid ? 1 : a.index - b.index;
            if (!bValid) return -1;
            return (sort === 'thickness-ascending' ? a.thickness - b.thickness : b.thickness - a.thickness) || this.collator.compare(a.title,b.title);
          }
          return a.index - b.index;
        });
        this.cards.forEach(card => { card.hidden = true; });
        const fragment = document.createDocumentFragment();
        matches.forEach((record,index) => {
          record.card.hidden = index >= this.limit;
          fragment.append(record.card);
          if (!record.card.hidden && this.observer) this.observer.observe(record.card);
        });
        this.grid.append(fragment);
        const visible = Math.min(this.limit, matches.length);
        const countTemplate = matches.length === 1 ? this.dataset.countOneTemplate : this.dataset.countTemplate;
        this.count.textContent = countTemplate.replace('__COUNT__', matches.length);
        this.empty.hidden = matches.length > 0;
        this.loadArea.hidden = matches.length === 0;
        this.loadButton.hidden = visible >= matches.length;
        const showingTemplate = matches.length === 1 ? this.dataset.showingOneTemplate : this.dataset.showingTemplate;
        this.showing.textContent = showingTemplate.replace('__COUNT__', visible).replace('__TOTAL__', matches.length);
        const hasFilters = Boolean(this.search.value || this.material.value !== this.defaultMaterial || this.series.value !== this.defaultSeries || this.colour.value || this.size.value || this.thickness.value || this.sort.value !== 'featured');
        this.querySelectorAll('[data-clear]').forEach(button => { button.disabled = !hasFilters; });
        this.querySelectorAll('[data-material-choice]').forEach(button => {
          if (this.material.value === button.dataset.materialChoice) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });
        this.colourChoices.querySelectorAll('[data-colour-choice]').forEach(button => button.setAttribute('aria-pressed', String(this.colour.value === button.dataset.colourChoice)));
        this.renderActiveFilters();
        if (updateUrl) {
          const url = new URL(window.location.href);
          const state = { cfh_q: this.search.value.trim(), cfh_material: this.material.value === this.defaultMaterial ? '' : this.material.value, cfh_series: this.series.value === this.defaultSeries ? '' : this.series.value, cfh_colour: this.colour.value, cfh_size: this.size.value, cfh_thickness: this.thickness.value, cfh_sort: this.sort.value === 'featured' ? '' : this.sort.value, cfh_limit: this.limit > 24 ? String(this.limit) : '' };
          Object.entries(state).forEach(([key,value]) => { if (value) url.searchParams.set(key,value); else url.searchParams.delete(key); });
          history.replaceState(history.state, '', url);
        }
        this.rememberCollection();
      }
      renderActiveFilters() {
        const fragment = document.createDocumentFragment();
        ['material', 'series', 'colour', 'size', 'thickness', 'search', 'sort'].forEach(key => {
          const control = this[key];
          if (!control.value || (key === 'material' && control.value === this.defaultMaterial) || (key === 'series' && control.value === this.defaultSeries) || (key === 'sort' && control.value === 'featured')) return;
          const label = key === 'search' ? '“' + control.value + '”' : control.selectedOptions[0].textContent;
          const button = document.createElement('button');
          button.type = 'button'; button.className = 'cfh__filter-chip'; button.dataset.removeFilter = key;
          button.textContent = label + ' ×'; button.setAttribute('aria-label', this.dataset.removeLabel + ' ' + label);
          fragment.append(button);
        });
        this.activeFilters.replaceChildren(fragment);
      }
      setupFilterPanel() {
        const panel = this.querySelector('[data-filter-panel]');
        const summary = panel.querySelector('summary');
        const mobile = window.matchMedia('(max-width: 1024px)');
        const options = { signal: this.abort.signal };
        const sync = () => { panel.open = !mobile.matches; };
        sync();
        mobile.addEventListener('change', sync, options);
        summary.addEventListener('click', event => { if (!mobile.matches) event.preventDefault(); }, options);
        this.querySelector('[data-close-filters]').addEventListener('click', () => {
          if (!mobile.matches) return;
          panel.open = false;
          summary.focus({ preventScroll: true });
        }, options);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cavador-flooring-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cavador-flooring-product')) {
  customElements.define('cavador-flooring-product', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.words = JSON.parse(this.querySelector('[data-translations]').textContent);
      this.coverage = Number(this.dataset.coverage);
      this.currency = new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: this.dataset.currency });
      this.querySelectorAll('[data-media-target]').forEach(button => button.addEventListener('click', () => {
        const media = document.getElementById(button.dataset.mediaTarget);
        if (media) this.querySelector('[data-gallery]').scrollTo({ left: media.offsetLeft - this.querySelector('[data-gallery]').offsetLeft });
      }));
      this.querySelector('[data-variant-select]')?.addEventListener('change', event => this.selectVariant(event.target.value));
      this.querySelector('[data-area]')?.addEventListener('input', () => this.calculate());
      this.querySelector('[data-extra]')?.addEventListener('input', () => this.calculate());
      this.querySelector('[data-use-calculation]')?.addEventListener('click', () => {
        const quantity = this.querySelector('[data-quantity]');
        if (quantity && this.calculatedBoxes > 0) { quantity.value = this.calculatedBoxes; quantity.dispatchEvent(new Event('change', { bubbles: true })); }
      });
      this.querySelector('form')?.addEventListener('submit', event => {
        const id = this.querySelector('[data-variant-id]')?.value;
        const variant = this.variants.find(value => String(value.id) === String(id));
        if (!variant || variant.price <= 0 || !variant.available) event.preventDefault();
      });
    }
    selectVariant(id) {
      const variant = this.variants.find(value => String(value.id) === String(id));
      if (!variant) return;
      const pending = variant.price <= 0;
      this.querySelector('[data-box-price]').textContent = pending ? this.words.pending : `${this.currency.format(variant.price / 100)} ${this.words.perBox}`;
      const areaPrice = this.querySelector('[data-area-price]');
      areaPrice.hidden = pending || !(this.coverage > 0);
      if (!areaPrice.hidden) areaPrice.textContent = `${this.currency.format(variant.price / 100 / this.coverage)} ${this.words.perSqft}`;
      this.querySelector('[data-current-sku]').textContent = variant.sku || '';
      const hiddenId = this.querySelector('[data-variant-id]');
      if (hiddenId) hiddenId.value = variant.id;
      const purchase = this.querySelector('[data-purchase]');
      if (purchase) purchase.hidden = pending;
      const add = this.querySelector('[data-add]');
      if (add) { add.disabled = pending || !variant.available; add.textContent = variant.available && !pending ? this.words.add : this.words.soldOut; }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
      if (this.querySelector('[data-area]')) this.calculate();
    }
    calculate() {
      const area = Number(this.querySelector('[data-area]').value);
      const extra = Number(this.querySelector('[data-extra]').value);
      const valid = Number.isFinite(area) && area > 0 && Number.isFinite(extra) && extra >= 0 && extra <= 100 && this.coverage > 0;
      this.calculatedBoxes = valid ? Math.ceil(area * (1 + extra / 100) / this.coverage) : 0;
      this.querySelector('[data-calculation]').textContent = valid ? this.words.boxResult.replace('[boxes]', String(this.calculatedBoxes)).replace('[coverage]', new Intl.NumberFormat(this.dataset.locale || 'en', { maximumFractionDigits: 2 }).format(this.calculatedBoxes * this.coverage)) : '';
      this.querySelector('[data-use-calculation]').hidden = !valid || !this.querySelector('[data-quantity]') || this.querySelector('[data-purchase]').hidden;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cavador-flooring-studio-cta"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cavador-vision-cta')) {
    customElements.define('cavador-vision-cta', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.mediaObserver?.disconnect();
        this.video?.pause();
        this.playbackVersion = (this.playbackVersion || 0) + 1;
        this.abort = new AbortController();
        this.link = this.querySelector('[data-vision-link]');
        const variants = JSON.parse(this.querySelector('[data-vision-variants]')?.textContent || '[]');
        const sync = () => {
          const owner = document.querySelector('.aurora-pdp[data-product-id="' + this.dataset.productId + '"]') || document.querySelector('.aurora-pdp');
          const picker = owner?.querySelector('select[name="id"]');
          if (!picker || !this.link || !this.dataset.productId) return;
          const url = new URL(this.link.href);
          url.searchParams.set('variant', picker.value);
          this.link.href = url.href;
          const finish = this.querySelector('[data-vision-finish]');
          if (finish) finish.textContent = picker.selectedOptions[0]?.textContent.trim() || '';
          const variant = variants.find(item => String(item.id) === picker.value);
          const image = this.querySelector('.cvcta__image');
          if (variant?.image && image) { image.src = variant.image; image.removeAttribute('srcset'); }
        };
        document.addEventListener('change', sync, { signal: this.abort.signal });
        this.link?.addEventListener('click', sync, { signal: this.abort.signal });
        sync();
        this.video = this.querySelector('.cvcta__video');
        this.media = this.querySelector('.cvcta__media');
        if (!this.video || !this.media) return;
        this.inView = false;
        this.videoFailed = false;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const options = { signal: this.abort.signal };
        const refresh = () => this.syncPlayback();
        this.video.addEventListener('playing', () => {
          if (!this.shouldPlay()) { this.video.pause(); return; }
          this.media.setAttribute('data-video-ready', '');
          this.media.removeAttribute('data-video-still');
        }, options);
        this.video.addEventListener('error', () => {
          this.videoFailed = true;
          this.syncPlayback();
        }, options);
        this.motion.addEventListener('change', refresh, options);
        document.addEventListener('visibilitychange', refresh, options);
        if ('IntersectionObserver' in window) {
          this.mediaObserver = new IntersectionObserver(entries => {
            this.inView = entries.some(entry => entry.isIntersecting);
            this.syncPlayback();
          }, { threshold: 0 });
          this.mediaObserver.observe(this.media);
        } else {
          this.inView = true;
        }
        this.syncPlayback();
      }
      shouldPlay() {
        return this.isConnected && this.inView && !document.hidden && !this.motion?.matches && this.media?.dataset.animatePreview !== 'false' && !this.videoFailed;
      }
      syncPlayback() {
        const video = this.video;
        const media = this.media;
        if (!video || !media) return;
        const attempt = ++this.playbackVersion;
        const still = this.motion?.matches || media.dataset.animatePreview === 'false' || this.videoFailed;
        media.toggleAttribute('data-video-still', Boolean(still));
        if (!this.shouldPlay()) { video.pause(); return; }
        if (!video.paused) return;
        Promise.resolve(video.play()).catch(() => {
          if (attempt === this.playbackVersion && this.video === video && !this.abort.signal.aborted) media.setAttribute('data-video-still', '');
        });
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.mediaObserver?.disconnect();
        this.mediaObserver = null;
        this.playbackVersion = (this.playbackVersion || 0) + 1;
        this.video?.pause();
        this.video = null;
        this.media = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cavador-installation-film"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(!customElements.get('cavador-editorial-film')){
    class CavadorEditorialFilm extends HTMLElement{
      connectedCallback(){
        if(this.controller)return;
        this.video=this.querySelector('video');
        this.button=this.querySelector('[data-editorial-play]');
        this.error=this.querySelector('[data-editorial-error]');
        if(!this.video||!this.button)return;
        this.controller=new AbortController();
        this.requestId=(this.requestId||0)+1;
        this.autoEnabled=this.dataset.autoplay!=='false';
        this.userPaused=this.userPaused===true;
        this.manualPlayback=this.manualPlayback===true;
        this.controlsRequested=this.controlsRequested===true;
        this.pointerOver=false;
        this.pageHidden=false;
        this.inView=false;
        this.managedPauseEvents=0;
        var options={signal:this.controller.signal};
        if(!this.everConnected){this.video.muted=true;this.everConnected=true;}
        this.video.loop=true;
        this.video.autoplay=false;
        this.video.controls=this.controlsRequested;
        this.button.hidden=false;
        this.motionQuery=window.matchMedia?window.matchMedia('(prefers-reduced-motion: reduce)'):null;
        this.reducedMotion=Boolean(this.motionQuery?.matches);
        this.motionChanged=()=>{this.reducedMotion=Boolean(this.motionQuery.matches);this.sync();};
        if(this.motionQuery?.addEventListener)this.motionQuery.addEventListener('change',this.motionChanged,options);
        else this.motionQuery?.addListener(this.motionChanged);
        this.button.addEventListener('click',()=>this.toggle(),options);
        this.video.addEventListener('play',()=>this.onPlay(),options);
        this.video.addEventListener('pause',()=>this.onPause(),options);
        this.video.addEventListener('ended',()=>this.update(),options);
        this.video.addEventListener('volumechange',()=>{
          if(this.audible()&&!this.video.paused){this.audioBlocked=false;this.claimAudio();}
          else if(!this.audible()){this.audioBlocked=false;this.sync();}
        },options);
        this.video.addEventListener('pointerenter',()=>{this.pointerOver=true;this.update();},options);
        this.video.addEventListener('pointerleave',()=>{this.pointerOver=false;this.update();},options);
        this.video.addEventListener('focusin',()=>this.update(),options);
        this.video.addEventListener('focusout',()=>this.update(),options);
        this.video.addEventListener('pointerdown',event=>{if(event.pointerType==='touch'){this.controlsRequested=true;this.update();}this.allowNativeStart();},options);
        this.video.addEventListener('keydown',event=>{if(event.key===' '||event.key==='Enter')this.allowNativeStart();},options);
        this.video.addEventListener('error',()=>this.showError(),options);
        document.addEventListener('cavador:acoustic-play',event=>{
          if(event.detail!==this&&this.audible()){this.audioBlocked=true;this.pauseManaged();}
        },options);
        document.addEventListener('visibilitychange',()=>this.sync(),options);
        window.addEventListener('pagehide',()=>{this.pageHidden=true;this.pauseManaged();},options);
        window.addEventListener('pageshow',()=>{this.pageHidden=false;this.sync();},options);
        if(window.IntersectionObserver){
          this.observer=new IntersectionObserver(entries=>{
            entries.forEach(entry=>{if(entry.target===this.video){this.inView=entry.isIntersecting&&entry.intersectionRatio!==0;this.sync();}});
          },{threshold:0.01});
          this.observer.observe(this.video);
        }else{
          this.viewChanged=()=>{var rect=this.video.getBoundingClientRect();this.inView=rect.bottom>0&&rect.top<window.innerHeight&&rect.width>0&&rect.height>0;this.sync();};
          window.addEventListener('scroll',this.viewChanged,{...options,passive:true});
          window.addEventListener('resize',this.viewChanged,options);
          this.viewChanged();
        }
        this.update();
      }
      disconnectedCallback(){
        this.pauseManaged();
        this.observer?.disconnect();
        if(!this.motionQuery?.removeEventListener)this.motionQuery?.removeListener(this.motionChanged);
        this.controller?.abort();
        this.controller=null;
      }
      audible(){return !this.video.muted&&this.video.volume>0;}
      eligible(){
        return this.isConnected&&this.inView&&!this.pageHidden&&document.visibilityState!=='hidden'&&!this.userPaused&&
          (this.manualPlayback||(this.autoEnabled&&!this.reducedMotion&&!this.autoBlocked))&&(!this.audioBlocked||!this.audible());
      }
      sync(){
        if(!this.video)return;
        if(!this.eligible()){this.pauseManaged();return;}
        if(this.video.paused&&(!this.pendingPlay||this.pendingPlay.canceled))this.start(false);
        this.update();
      }
      async start(manual){
        if(!this.eligible())return;
        if(this.video.ended)this.video.currentTime=0;
        var request=++this.requestId;
        var pending={request:request,canceled:false};
        this.pendingPlay=pending;
        this.clearError();
        this.video.autoplay=!manual&&!this.manualPlayback&&this.autoEnabled&&!this.reducedMotion;
        this.video.controls=this.controlsRequested;
        try{
          await this.video.play();
          if(this.pendingPlay===pending&&(pending.canceled||!this.eligible()))this.pauseManaged();
        }catch(error){
          if(request===this.requestId&&this.isConnected&&!pending.canceled&&error.name!=='AbortError'){
            if(manual)this.showError();
            else{this.autoBlocked=true;this.video.autoplay=false;}
          }
        }finally{if(this.pendingPlay===pending)this.pendingPlay=null;}
        this.update();
      }
      toggle(){
        if(!this.video.paused&&!this.video.ended){
          this.userPaused=true;this.manualPlayback=false;this.pauseManaged();return;
        }
        this.userPaused=false;this.manualPlayback=true;this.autoBlocked=false;this.audioBlocked=false;this.controlsRequested=true;
        return this.start(true);
      }
      pauseManaged(){
        this.requestId=(this.requestId||0)+1;
        if(this.pendingPlay)this.pendingPlay.canceled=true;
        if(this.video){
          this.video.autoplay=false;
          if(!this.video.paused)this.managedPauseEvents=(this.managedPauseEvents||0)+1;
          this.video.pause();
        }
        this.update();
      }
      onPlay(){
        if(this.video.paused)return;
        if(this.pendingPlay?.canceled||!this.eligible()){this.pauseManaged();return;}
        this.video.controls=this.controlsRequested;
        this.clearError();this.update();
        if(this.audible())this.claimAudio();
      }
      onPause(){
        if(this.managedPauseEvents>0){this.managedPauseEvents-=1;this.update();return;}
        if(!this.video.paused)return;
        if(this.pendingPlay?.canceled){this.update();return;}
        if(!this.isConnected||!this.inView||this.pageHidden||document.visibilityState==='hidden'){this.update();return;}
        this.userPaused=true;this.manualPlayback=false;
        this.requestId+=1;
        if(this.pendingPlay)this.pendingPlay.canceled=true;
        this.video.autoplay=false;
        this.update();
      }
      claimAudio(){document.dispatchEvent(new CustomEvent('cavador:acoustic-play',{detail:this}));}
      allowNativeStart(){
        if(!this.video.controls)return;
        if(this.video.paused){
          this.requestId+=1;this.pendingPlay=null;this.userPaused=false;this.manualPlayback=true;this.autoBlocked=false;this.audioBlocked=false;
        }
      }
      update(){
        if(!this.video||!this.button)return;
        var playing=!this.video.paused&&!this.video.ended;
        if(playing&&document.activeElement===this.button)this.video.focus({preventScroll:true});
        this.button.hidden=playing;
        this.video.controls=this.controlsRequested||(!this.classList.contains('cav-film--full-bleed')&&this.pointerOver)||this.video.matches(':focus-within');
        var label=this.video.ended?this.dataset.replayLabel:this.dataset.playLabel;
        this.button.querySelector('span').textContent=label;
        this.button.setAttribute('aria-label',label);
      }
      clearError(){if(this.error){this.error.hidden=true;this.error.textContent='';}}
      showError(){if(this.error){this.error.textContent=this.dataset.errorLabel;this.error.hidden=false;}}
    }
    customElements.define('cavador-editorial-film',CavadorEditorialFilm);
  }
  function setup(el){
    if(el.dataset.cfReady)return;
    var v=el.querySelector('video'),play=el.querySelector('.cav-film__play');
    if(!v||!play)return;
    el.dataset.cfReady='1';
    function show(){var f=document.activeElement===v;el.classList.remove('is-playing');el.querySelector('.cav-film__overlay').inert=false;v.controls=false;if(f)play.focus({preventScroll:true});}
    function hide(){el.classList.add('is-playing');v.controls=true;el.querySelector('.cav-film__overlay').inert=true;v.focus({preventScroll:true});}
    function start(t){
      function go(){if(t!=null){try{v.currentTime=Math.max(0,Math.min(t,Number.isFinite(v.duration)?Math.max(0,v.duration-.1):t));}catch(e){}}var p=v.play();if(p&&p.catch)p.catch(show);}
      if(t!=null&&v.readyState<1){v.preload='metadata';v.addEventListener('loadedmetadata',go,{once:true});v.load();}else go();
    }
    v.addEventListener('play',hide);
    v.addEventListener('ended',show);
    play.addEventListener('click',function(){start(null);});
    el.querySelectorAll('[data-start]').forEach(function(b){b.addEventListener('click',function(){start(parseFloat(b.dataset.start)||0);});});
    v.controls=false;
    el.querySelectorAll('[data-cf-js]').forEach(function(n){n.hidden=false;});
    el.classList.add('is-enhanced');
  }
  function all(r){(r||document).querySelectorAll('[data-cav-film]').forEach(setup);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){all();});else all();
  document.addEventListener('shopify:section:load',function(e){all(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cavador-trade-process"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cavador-trade-flow')) {
  import('@theme/component').then(({ Component }) => {
    if (customElements.get('cavador-trade-flow')) return;

    class CavadorTradeFlow extends Component {
      playedSteps = new WeakSet();

      connectedCallback() {
        super.connectedCallback();
        this.initializeFlow();
      }

      updatedCallback() {
        super.updatedCallback();
        this.initializeFlow();
      }

      disconnectedCallback() {
        this.cleanupFlow();
        super.disconnectedCallback();
      }

      initializeFlow() {
        this.cleanupFlow();
        if (!this.classList.contains('cflow--animated')) return;
        const state = {
          controller: new AbortController(),
          motion: window.matchMedia('(prefers-reduced-motion: reduce)'),
          observer: null,
        };
        this.flowState = state;
        state.motion.addEventListener('change', () => this.observeFlow(state), {
          signal: state.controller.signal,
        });
        this.observeFlow(state);
      }

      observeFlow(state) {
        if (this.flowState !== state || state.controller.signal.aborted) return;
        state.observer?.disconnect();
        state.observer = null;
        if (state.motion.matches) {
          for (const step of this.querySelectorAll('.cflow__step')) step.classList.remove('is-playing');
          return;
        }
        if (!('IntersectionObserver' in window)) return;
        state.observer = new IntersectionObserver((entries) => {
          if (this.flowState !== state || state.controller.signal.aborted) return;
          for (const entry of entries) {
            if (!entry.isIntersecting || entry.intersectionRatio < .35) continue;
            const step = entry.target.closest('.cflow__step');
            if (!step || !this.contains(step) || this.playedSteps.has(step)) continue;
            this.playedSteps.add(step);
            step.classList.add('is-playing');
            state.observer.unobserve(entry.target);
          }
        }, { threshold: .35 });
        for (const art of this.querySelectorAll('.cflow__art')) {
          const step = art.closest('.cflow__step');
          if (step && !this.playedSteps.has(step)) state.observer.observe(art);
        }
      }

      cleanupFlow() {
        const state = this.flowState;
        this.flowState = null;
        state?.observer?.disconnect();
        state?.controller.abort();
        for (const step of this.querySelectorAll('.cflow__step')) step.classList.remove('is-playing');
      }
    }

    customElements.define('cavador-trade-flow', CavadorTradeFlow);
  }).catch(() => {});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero_luxury"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('cavador-home-hero')) return;

  class CavadorHomepageHero extends HTMLElement {
    connectedCallback() {
      this._heCleanup();
      const epoch = this._heEpoch;
      this._heView = this.ownerDocument.defaultView || window;
      this._heStartFrame = this._heView.requestAnimationFrame(() => {
        this._heStartFrame = null;
        if (this.isConnected && this._heEpoch === epoch) this._heInitialize(epoch);
      });
    }

    disconnectedCallback() {
      this._heCleanup();
    }

    _heInitialize(epoch) {
      this._heAbort = new AbortController();
      const controller = this._heAbort;
      const options = { signal: controller.signal };
      const primary = this.querySelector('video[data-he-video]');
      if (!primary || typeof primary.play !== 'function') return;
      this._hePrimary = primary;
      this._hePreparePlaylist(primary);
      const source = primary.querySelector('source[data-he-src]');
      if (!source?.dataset.heSrc) return;
      this._heVideos = [primary];
      const buffer = this.querySelector('video[data-he-buffer]');
      if (buffer && buffer !== primary && typeof buffer.play === 'function') this._heVideos.push(buffer);
      const selected = this._heSelection || { id: '__fallback', source: {
        url: source.dataset.heSrc, mime: source.getAttribute('type') || '' } };
      this._heActive = this._heConfigureVideo(primary, selected);
      this._heVideo = primary;
      this._heBuffer = this._heVideos[1] || null;
      this._hePageSuspended = false;
      this._heMotion = this._heView.matchMedia?.('(prefers-reduced-motion: reduce)') || null;
      this._heConnection = this._heView.navigator?.connection || null;
      const current = () => !controller.signal.aborted && this.isConnected && this._heEpoch === epoch;
      const update = () => { if (current()) this._heUpdate(); };
      if (this.dataset.heDesignMode === 'true') {
        this.ownerDocument.addEventListener('shopify:block:select', event => this._hePreviewBlock(event), options);
      }
      if (this._heMotion?.addEventListener) this._heMotion.addEventListener('change', update, options);
      else if (this._heMotion?.addListener) {
        this._heMotion.addListener(update);
        this._heLegacyMotionListener = update;
      }
      this._heConnection?.addEventListener?.('change', update, options);
      this.ownerDocument.addEventListener('visibilitychange', update, options);
      this._heView.addEventListener('pagehide', () => {
        if (!current()) return;
        this._hePageSuspended = true;
        this._heStop();
      }, options);
      this._heView.addEventListener('pageshow', () => {
        if (!current()) return;
        this._hePageSuspended = false;
        update();
      }, options);
      this._heVisible = this._heInView();
      if (typeof this._heView.IntersectionObserver === 'function') {
        this._heObserver = new this._heView.IntersectionObserver(entries => {
          if (!current()) return;
          for (const entry of entries) {
            if (entry.target === this) this._heVisible = entry.isIntersecting && entry.intersectionRatio >= 0.1;
          }
          update();
        }, { threshold: [0, 0.1] });
        this._heObserver.observe(this);
      } else {
        const measure = () => {
          if (this._heVisibilityFrame != null) return;
          this._heVisibilityFrame = this._heView.requestAnimationFrame(() => {
            this._heVisibilityFrame = null;
            if (!current()) return;
            this._heVisible = this._heInView();
            update();
          });
        };
        this._heView.addEventListener('scroll', measure, { ...options, passive: true, capture: true });
        this._heView.addEventListener('resize', measure, { ...options, passive: true });
      }
      for (const video of this._heVideos) {
        video.addEventListener('playing', () => {
          if (!current()) return;
          const slot = this._heStates?.get(video);
          if (!slot || video.paused || !this._heMatches(slot)) return;
          if (!this._heAllowed()) { this._heStop(); return; }
          slot.pending = false;
          slot.hasFrame = true;
          if (this._heTransition?.incoming === slot) this._heBeginFade(this._heTransition);
          else if (this._heActive === slot && !this._heTransition) {
            video.setAttribute('data-he-visible', '');
            video.setAttribute('data-he-front', '');
            this.setAttribute('data-he-playing', '');
            this._heMaybePreload();
          }
        }, options);
        video.addEventListener('pause', () => {
          if (!current() || !video.paused) return;
          const slot = this._heStates?.get(video);
          if (!slot) return;
          slot.pending = false;
          if (this._heTransition?.incoming === slot && !video.ended) this._heCancelFade();
          if (this._heActive === slot && !video.ended && !this._heTransition) this.removeAttribute('data-he-playing');
        }, options);
        video.addEventListener('timeupdate', () => {
          if (current() && this._heActive?.video === video) this._heMaybePreload();
        }, options);
        video.addEventListener('ended', () => {
          if (!current()) return;
          const slot = this._heStates?.get(video);
          if (!slot || !video.ended || video.loop || slot.pending || !slot.loaded || !this._heMatches(slot) ||
            this.getAttribute('data-he-playlist-mode') !== 'sequence') return;
          if (this._heTransition?.incoming === slot && this._heTransition.fading) {
            this._heFinishFade(this._heTransition);
          }
          if (this._heActive === slot && !this._heTransition) this._heAdvancePlaylist();
        }, options);
        video.addEventListener('error', () => {
          if (!current() || !video.error) return;
          const slot = this._heStates?.get(video);
          if (!slot?.loaded || !this._heMatches(slot, false)) return;
          slot.failed = true;
          slot.attempt++;
          slot.pending = false;
          video.pause();
          if (this._heTransition?.incoming === slot) this._heCancelFade();
          else if (this._heActive === slot) this.removeAttribute('data-he-playing');
        }, options);
        video.addEventListener('transitionend', event => {
          if (!current() || event.target !== video || event.propertyName !== 'opacity') return;
          const transition = this._heTransition;
          if (transition?.incoming.video === video && transition.fading) this._heFinishFade(transition);
        }, options);
      }
      update();
    }

    _heConfigureVideo(video, selection) {
      let source = video.querySelector('source[data-he-src]') || video.querySelector('source');
      if (!source) {
        source = this.ownerDocument.createElement('source');
        video.append(source);
      }
      source.dataset.heSrc = selection.source.url;
      if (selection.source.mime) source.setAttribute('type', selection.source.mime);
      else source.removeAttribute('type');
      for (const extra of video.querySelectorAll('source')) {
        if (extra === source) continue;
        extra.removeAttribute('src');
        extra.removeAttribute('data-he-src');
      }
      const signature = JSON.stringify({ url: selection.source.url, mime: selection.source.mime || '' });
      this._heStates ??= new WeakMap();
      let slot = this._heStates.get(video);
      if (!slot || slot.signature !== signature) {
        if (slot) this._heRelease(slot);
        slot = { video, source, selection, signature, loaded: false, blocked: false, failed: false,
          pending: false, hasFrame: false, attempt: 0 };
        this._heStates.set(video, slot);
      } else {
        slot.source = source;
        slot.selection = selection;
      }
      video.autoplay = false;
      video.removeAttribute('autoplay');
      video.controls = false;
      video.removeAttribute('controls');
      video.muted = true;
      video.defaultMuted = true;
      video.loop = this.getAttribute('data-he-playlist-mode') !== 'sequence';
      video.playsInline = true;
      video.preload = 'none';
      if (video === this._hePrimary) this._heAppliedSource = { node: source,
        url: selection.source.url, mime: selection.source.mime || '' };
      return slot;
    }

    _heReadPlaylist() {
      let entries;
      try {
        entries = JSON.parse(this.querySelector('script[type="application/json"][data-he-playlist]')?.textContent || '[]');
      } catch { return []; }
      if (!Array.isArray(entries)) return [];
      const candidates = [];
      const seenIds = new Set();
      const urlOwners = new Map();
      for (const entry of entries) {
        if (!entry || typeof entry !== 'object' || Array.isArray(entry) ||
          typeof entry.id !== 'string' || !entry.id.trim() || !Array.isArray(entry.sources)) continue;
        const id = entry.id.trim();
        if (seenIds.has(id)) continue;
        const sourceUrls = new Set();
        const sources = [];
        for (const item of entry.sources) {
          if (!item || typeof item !== 'object' || typeof item.url !== 'string' || !item.url.trim()) continue;
          if (!['number', 'string'].includes(typeof item.width) ||
            (item.mime !== undefined && typeof item.mime !== 'string')) continue;
          const width = Number(item.width);
          if (!Number.isFinite(width) || width <= 0) continue;
          const mime = typeof item.mime === 'string' && item.mime.trim() ? item.mime.trim() : 'video/mp4';
          if (!/^video\//i.test(mime)) continue;
          let url;
          try {
            const parsed = new URL(item.url.trim(), this.ownerDocument.baseURI);
            if (!['https:', 'http:'].includes(parsed.protocol)) continue;
            url = parsed.href;
          } catch { continue; }
          if (sourceUrls.has(url)) continue;
          sourceUrls.add(url);
          sources.push({ url, mime, width });
        }
        if (!sources.length) continue;
        seenIds.add(id);
        sources.sort((a, b) => a.url.localeCompare(b.url) || a.width - b.width || a.mime.localeCompare(b.mime));
        const owners = [...new Set(sources.map(source => urlOwners.get(source.url)).filter(Boolean))]
          .sort((a, b) => candidates.indexOf(a) - candidates.indexOf(b));
        const owner = owners[0];
        if (owner) {
          const merged = new Map(owner.sources.map(source => [source.url, source]));
          for (const duplicate of owners.slice(1)) {
            owner.ids.push(...duplicate.ids);
            for (const source of duplicate.sources) if (!merged.has(source.url)) merged.set(source.url, source);
            candidates.splice(candidates.indexOf(duplicate), 1);
          }
          owner.ids.push(id);
          for (const source of sources) if (!merged.has(source.url)) merged.set(source.url, source);
          owner.sources = [...merged.values()].sort((a, b) => a.url.localeCompare(b.url) ||
            a.width - b.width || a.mime.localeCompare(b.mime));
          owner.fingerprint = JSON.stringify(owner.sources);
          for (const source of owner.sources) urlOwners.set(source.url, owner);
          continue;
        }
        const candidate = { id, ids: [id], sources, fingerprint: JSON.stringify(sources) };
        candidates.push(candidate);
        for (const source of sources) urlOwners.set(source.url, candidate);
      }
      return candidates;
    }

    _heChooseRendition(candidate) {
      const target = this._heView.innerWidth < 900 ? 720 : 1280;
      return [...candidate.sources].sort((a, b) => Math.abs(a.width - target) - Math.abs(b.width - target) ||
        a.width - b.width || a.url.localeCompare(b.url))[0];
    }

    _hePreparePlaylist(video) {
      const source = video.querySelector('source[data-he-src]') || video.querySelector('source');
      if (!source) return;
      this._heFallbacks ??= new WeakMap();
      let fallback = this._heFallbacks.get(source);
      const currentUrl = source.dataset.heSrc || '';
      const currentMime = source.getAttribute('type') || '';
      if (!fallback || (this._heAppliedSource?.node === source &&
        (currentUrl !== this._heAppliedSource.url || currentMime !== this._heAppliedSource.mime))) {
        fallback = { url: currentUrl, mime: currentMime };
        this._heFallbacks.set(source, fallback);
      }
      const enabled = this.dataset.hePlaylistEnabled === 'true';
      if (this._hePlaylistEnabled !== undefined && this._hePlaylistEnabled !== enabled) {
        this._heSelection = null;
        this._hePreviewId = null;
      }
      this._hePlaylistEnabled = enabled;
      const candidates = this._heCandidates = this._heReadPlaylist();
      let candidate = candidates.find(item => item.ids.includes(this._heSelection?.id));
      if (!candidate || candidate.fingerprint !== this._heSelection?.fingerprint) this._heSelection = null;
      if (this._hePreviewId && !candidates.some(item => item.ids.includes(this._hePreviewId))) this._hePreviewId = null;
      if (!this._heSelection && this._hePreviewId) {
        candidate = candidates.find(item => item.ids.includes(this._hePreviewId));
        if (candidate) this._heSelection = { id: this._hePreviewId, fingerprint: candidate.fingerprint,
          source: this._heChooseRendition(candidate) };
      }
      if (!this._heSelection && enabled && candidates.length) {
        const index = this.dataset.heDesignMode === 'true' ? 0 : Math.min(candidates.length - 1,
          Math.max(0, Math.floor(Math.random() * candidates.length)));
        candidate = candidates[index];
        this._heSelection = { id: candidate.id, fingerprint: candidate.fingerprint,
          source: this._heChooseRendition(candidate) };
      }
      this.setAttribute('data-he-playlist-mode', enabled && candidates.length > 1 &&
        this.dataset.heDesignMode !== 'true' ? 'sequence' : 'single');
      const selected = this._heSelection?.source || fallback;
      this.setAttribute('data-he-active-clip', this._heSelection?.id || '__fallback');
      source.dataset.heSrc = selected.url;
      if (selected.mime) source.setAttribute('type', selected.mime);
      else source.removeAttribute('type');
      if (!selected.url) source.removeAttribute('src');
      for (const extra of video.querySelectorAll('source')) {
        if (extra === source) continue;
        extra.removeAttribute('src');
        extra.removeAttribute('data-he-src');
      }
      this._heAppliedSource = { node: source, url: selected.url, mime: selected.mime };
    }

    _heNextSelection() {
      const candidates = this._heReadPlaylist();
      if (candidates.length < 2) return null;
      const index = candidates.findIndex(candidate => candidate.ids.includes(this._heActive?.selection.id));
      const next = candidates[(index + 1) % candidates.length];
      return { id: next.id, fingerprint: next.fingerprint, source: this._heChooseRendition(next) };
    }

    _hePrepareBuffer(selection) {
      if (!this._heBuffer) return null;
      return this._heConfigureVideo(this._heBuffer, selection);
    }

    _heMaybePreload() {
      const slot = this._heActive;
      if (!slot || this._heTransition || !this._heBuffer || !this._heAllowed() || !slot.hasFrame ||
        this.getAttribute('data-he-playlist-mode') !== 'sequence') return;
      const duration = slot.video.duration;
      const remaining = duration - slot.video.currentTime;
      if (!Number.isFinite(duration) || duration <= 0 || remaining <= 0 || remaining > 3) return;
      const selection = this._heNextSelection();
      if (selection) this._heLoad(this._hePrepareBuffer(selection));
    }

    _heAdvancePlaylist() {
      if (this._heTransition) return;
      const next = this._heNextSelection();
      if (!next) return;
      this._heSelection = next;
      this._hePreviewId = null;
      const incoming = this._hePrepareBuffer(next);
      if (!incoming) { this.connectedCallback(); return; }
      this._heTransition = { outgoing: this._heActive, incoming, fading: false, waitingFrame: false };
      this.setAttribute('data-he-transition', 'buffering');
      this._heUpdate();
    }

    _hePreviewBlock(event) {
      if (!this.isConnected || this.dataset.heDesignMode !== 'true' || typeof event.detail?.blockId !== 'string') return;
      const id = event.detail.blockId;
      const candidate = this._heReadPlaylist().find(item => item.ids.includes(id));
      if (!candidate) return;
      const source = candidate.fingerprint === this._heSelection?.fingerprint ?
        this._heSelection.source : this._heChooseRendition(candidate);
      this._hePlaylistEnabled = this.dataset.hePlaylistEnabled === 'true';
      this._hePreviewId = id;
      this._heSelection = { id, fingerprint: candidate.fingerprint, source };
      const active = this._heActive;
      if (active && active.selection.source.url === source.url && active.selection.source.mime === source.mime &&
        !active.blocked && !active.failed) {
        this.setAttribute('data-he-active-clip', id);
        return;
      }
      for (const video of this._heVideos || []) {
        this._heRelease(this._heStates?.get(video));
        this._heStates?.delete(video);
      }
      this.connectedCallback();
    }

    _heInView() {
      const rect = this.getBoundingClientRect();
      if (!rect.height || rect.width <= 0 || rect.right <= 0 || rect.left >= this._heView.innerWidth) return false;
      const visible = Math.max(0, Math.min(rect.bottom, this._heView.innerHeight) - Math.max(rect.top, 0));
      return visible / rect.height >= 0.1;
    }

    _heAllowed() {
      return Boolean(this.isConnected && this._heVisible && !this._hePageSuspended && !this.ownerDocument.hidden &&
        !this._heMotion?.matches && !this._heConnection?.saveData &&
        !['slow-2g', '2g'].includes(this._heConnection?.effectiveType));
    }

    _heMatches(slot, currentSource = true) {
      if (!slot.loaded || slot.source.getAttribute('src') !== slot.selection.source.url) return false;
      if (!currentSource) return true;
      try { return new URL(slot.selection.source.url, this.ownerDocument.baseURI).href === slot.video.currentSrc; }
      catch { return false; }
    }

    _heLoad(slot) {
      if (!slot || !this._heAllowed() || slot.blocked || slot.failed) return false;
      if (slot.loaded && slot.source.getAttribute('src') === slot.selection.source.url) return true;
      slot.attempt++;
      slot.pending = false;
      slot.hasFrame = false;
      slot.source.setAttribute('src', slot.selection.source.url);
      slot.video.preload = 'auto';
      slot.loaded = true;
      try { slot.video.load(); }
      catch { slot.failed = true; return false; }
      return true;
    }

    _hePlay(slot) {
      if (!slot || slot.pending || !slot.video.paused || !this._heLoad(slot)) return;
      const controller = this._heAbort;
      const epoch = this._heEpoch;
      const attempt = ++slot.attempt;
      slot.pending = true;
      const current = () => !controller.signal.aborted && this.isConnected && this._heEpoch === epoch &&
        this._heStates.get(slot.video) === slot && slot.attempt === attempt;
      const failed = error => {
        if (!current()) return;
        slot.pending = false;
        slot.blocked = true;
        slot.failed = error?.name === 'NotSupportedError' || Boolean(slot.video.error);
        slot.attempt++;
        slot.video.pause();
        if (this._heTransition?.incoming === slot) this._heCancelFade();
        else if (this._heActive === slot) this.removeAttribute('data-he-playing');
      };
      try {
        Promise.resolve(slot.video.play()).then(() => {
          if (!current()) return;
          slot.pending = false;
          if (!this._heAllowed()) this._heStop();
        }, failed);
      } catch (error) { failed(error); }
    }

    _heUpdate() {
      if (!this._heActive) return;
      if (!this._heAllowed()) { this._heStop(); return; }
      const transition = this._heTransition;
      if (transition) {
        if (transition.outgoing.hasFrame) {
          transition.outgoing.video.setAttribute('data-he-visible', '');
          this.setAttribute('data-he-playing', '');
        }
        this._hePlay(transition.incoming);
        return;
      }
      this._hePlay(this._heActive);
      this._heMaybePreload();
    }

    _heBeginFade(transition) {
      if (this._heTransition !== transition || transition.fading || transition.waitingFrame || !this._heAllowed()) return;
      transition.waitingFrame = true;
      const epoch = this._heEpoch;
      const ready = () => {
        if (!this.isConnected || this._heEpoch !== epoch || this._heTransition !== transition) return;
        this._heFadeFrame = null;
        this._heVideoFrame = null;
        transition.waitingFrame = false;
        if (!this._heAllowed() || transition.incoming.video.paused || !this._heMatches(transition.incoming)) return;
        transition.fading = true;
        transition.outgoing.video.setAttribute('data-he-visible', '');
        transition.outgoing.video.removeAttribute('data-he-front');
        transition.incoming.video.setAttribute('data-he-front', '');
        transition.incoming.video.setAttribute('data-he-visible', '');
        this.setAttribute('data-he-playing', '');
        this.setAttribute('data-he-active-clip', transition.incoming.selection.id);
        this.setAttribute('data-he-transition', 'fading');
        this._heFadeTimer = this._heView.setTimeout(() => this._heFinishFade(transition), 1200);
      };
      const video = transition.incoming.video;
      if (typeof video.requestVideoFrameCallback === 'function') {
        this._heVideoFrame = { video, id: video.requestVideoFrameCallback(ready) };
      } else this._heFadeFrame = this._heView.requestAnimationFrame(ready);
    }

    _heFinishFade(transition) {
      if (this._heTransition !== transition || !transition.fading || !this._heAllowed() ||
        transition.incoming.failed || !transition.incoming.hasFrame || !this._heMatches(transition.incoming)) return;
      this._heClearFadeCallbacks();
      this._heActive = transition.incoming;
      this._heVideo = transition.incoming.video;
      this._heBuffer = transition.outgoing.video;
      this._heSelection = transition.incoming.selection;
      this._heTransition = null;
      this.removeAttribute('data-he-transition');
      this.setAttribute('data-he-active-clip', this._heActive.selection.id);
      this._heRelease(transition.outgoing);
      this._heMaybePreload();
    }

    _heClearFadeCallbacks() {
      if (this._heFadeTimer != null) this._heView?.clearTimeout(this._heFadeTimer);
      if (this._heFadeFrame != null) this._heView?.cancelAnimationFrame(this._heFadeFrame);
      if (this._heVideoFrame) this._heVideoFrame.video.cancelVideoFrameCallback?.(this._heVideoFrame.id);
      this._heFadeTimer = null;
      this._heFadeFrame = null;
      this._heVideoFrame = null;
    }

    _heCancelFade() {
      this._heClearFadeCallbacks();
      const transition = this._heTransition;
      if (!transition) return;
      transition.fading = false;
      transition.waitingFrame = false;
      transition.incoming.video.removeAttribute('data-he-visible');
      transition.incoming.video.removeAttribute('data-he-front');
      if (transition.outgoing.hasFrame) {
        transition.outgoing.video.setAttribute('data-he-visible', '');
        transition.outgoing.video.setAttribute('data-he-front', '');
      }
      this.setAttribute('data-he-active-clip', transition.outgoing.selection.id);
      this.setAttribute('data-he-transition', 'buffering');
    }

    _hePause(slot) {
      if (!slot) return;
      slot.attempt++;
      slot.pending = false;
      slot.video.pause();
    }

    _heRelease(slot) {
      if (!slot) return;
      this._hePause(slot);
      slot.video.removeAttribute('data-he-visible');
      slot.video.removeAttribute('data-he-front');
      slot.video.preload = 'none';
      slot.video.removeAttribute('src');
      for (const source of slot.video.querySelectorAll('source')) source.removeAttribute('src');
      const loaded = slot.loaded;
      slot.loaded = false;
      slot.hasFrame = false;
      if (loaded) {
        try { slot.video.load(); } catch {}
      }
    }

    _heStop() {
      this._heCancelFade();
      this._hePause(this._heActive);
      const buffer = this._heStates?.get(this._heBuffer);
      if (buffer && buffer !== this._heActive) this._heRelease(buffer);
      this.removeAttribute('data-he-playing');
    }

    _heCleanup() {
      this._heEpoch = (this._heEpoch || 0) + 1;
      this._heAbort?.abort();
      this._heAbort = null;
      if (this._heStartFrame != null) this._heView.cancelAnimationFrame(this._heStartFrame);
      if (this._heVisibilityFrame != null) this._heView.cancelAnimationFrame(this._heVisibilityFrame);
      this._heStartFrame = null;
      this._heVisibilityFrame = null;
      this._heClearFadeCallbacks();
      this._heObserver?.disconnect();
      this._heObserver = null;
      if (this._heLegacyMotionListener) this._heMotion?.removeListener(this._heLegacyMotionListener);
      this._heLegacyMotionListener = null;
      for (const video of this._heVideos || []) this._heRelease(this._heStates?.get(video));
      this.removeAttribute('data-he-playing');
      this.removeAttribute('data-he-transition');
      this._heTransition = null;
      this._heActive = null;
      this._heVideo = null;
      this._heBuffer = null;
      this._heVideos = null;
      this._heMotion = null;
      this._heConnection = null;
    }
  }

  customElements.define('cavador-home-hero', CavadorHomepageHero);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-studio-ai"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cavador-home-studio')) {
  import('@theme/component').then(({ Component }) => {
    if (customElements.get('cavador-home-studio')) return;

    /**
     * @typedef {Object} StudioRefs
     * @property {HTMLElement | undefined} preview
     * @property {HTMLElement[] | undefined} frames
     * @property {HTMLElement | undefined} controls
     * @property {HTMLButtonElement[] | undefined} choices
     */
    /** @extends {Component<StudioRefs>} */
    class CavadorHomeStudio extends Component {
      studioSelection = null;

      connectedCallback() {
        super.connectedCallback();
        this.initializeStudio();
      }

      updatedCallback() {
        super.updatedCallback();
        this.initializeStudio();
      }

      disconnectedCallback() {
        this.cleanupStudio();
        super.disconnectedCallback();
      }

      initializeStudio() {
        this.cleanupStudio();
        const preview = this.refs.preview;
        const allFrames = this.refs.frames || [];
        if (!preview || !allFrames.length) return;
        const view = this.ownerDocument.defaultView || window;
        const state = {
          view,
          controller: new AbortController(),
          motion: view.matchMedia('(prefers-reduced-motion: reduce)'),
          observer: null,
          timer: null,
          allFrames,
          frames: [],
          choices: this.refs.choices || [],
          controls: this.refs.controls,
          visible: !('IntersectionObserver' in view),
          ready: false,
          running: false,
          legacyMotionListener: null,
        };
        this.studioState = state;
        if (state.controls) state.controls.hidden = true;

        const updateMotion = () => {
          if (!this.isStudioCurrent(state)) return;
          if (state.motion.matches) {
            this.stopPlayback(state);
            if (state.ready) this.setFrame(state, this.studioSelection, true);
          } else this.maybePlay(state);
        };
        if (state.motion.addEventListener) {
          state.motion.addEventListener('change', updateMotion, { signal: state.controller.signal });
        } else if (state.motion.addListener) {
          state.motion.addListener(updateMotion);
          state.legacyMotionListener = updateMotion;
        }
        this.ownerDocument.addEventListener('visibilitychange', () => {
          if (!this.isStudioCurrent(state)) return;
          if (this.ownerDocument.hidden) this.stopPlayback(state);
          else this.maybePlay(state);
        }, { signal: state.controller.signal });

        if ('IntersectionObserver' in view) {
          state.observer = new view.IntersectionObserver((entries) => {
            if (!this.isStudioCurrent(state)) return;
            for (const entry of entries) {
              state.visible = entry.isIntersecting && entry.intersectionRatio >= .35;
              if (!state.visible) this.stopPlayback(state);
              else this.maybePlay(state);
            }
          }, { threshold: [0, .35] });
          state.observer.observe(preview);
        }

        Promise.all(allFrames.map(async (frame) => {
          const image = frame.querySelector('img');
          if (!image) return null;
          const loaded = await this.waitForImage(image, state);
          if (!loaded || !this.isStudioCurrent(state)) return null;
          if (typeof image.decode === 'function') {
            try { await image.decode(); } catch { /* A loaded image can still render if decode rejects. */ }
          }
          return image.naturalWidth > 0 ? frame : null;
        })).then((loadedFrames) => {
          if (!this.isStudioCurrent(state)) return;
          state.frames = loadedFrames.filter(Boolean);
          state.ready = true;
          this.classList.toggle('chsa--media-unavailable', !state.frames.length);
          const availableNames = new Set(state.frames.map(frame => frame.dataset.studioFrame));
          for (const choice of state.choices) choice.hidden = !availableNames.has(choice.dataset.studioChoice);
          if (!state.frames.length) return;
          const selected = availableNames.has(this.studioSelection) ? this.studioSelection : state.frames[0].dataset.studioFrame;
          this.setFrame(state, selected, true);
          if (state.controls) state.controls.hidden = state.frames.length < 2;
          this.maybePlay(state);
        }).catch(() => {
          // Keep the original static view and hidden controls if enhancement fails.
        });
      }

      isStudioCurrent(state) {
        return this.studioState === state && !state.controller.signal.aborted && this.isConnected;
      }

      waitForImage(image, state) {
        if (image.complete) return Promise.resolve(image.naturalWidth > 0);
        return new Promise((resolve) => {
          const signal = state.controller.signal;
          const finish = (loaded) => {
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
            signal.removeEventListener('abort', onAbort);
            resolve(loaded);
          };
          const onLoad = () => finish(image.naturalWidth > 0);
          const onError = () => finish(false);
          const onAbort = () => finish(false);
          image.addEventListener('load', onLoad, { once: true, signal });
          image.addEventListener('error', onError, { once: true, signal });
          signal.addEventListener('abort', onAbort, { once: true });
          if (signal.aborted) finish(false);
        });
      }

      maybePlay(state) {
        if (!this.isStudioCurrent(state) || !state.ready || !state.visible || state.running ||
          state.frames.length < 2 || state.motion.matches || this.ownerDocument.hidden) return;
        state.running = true;
        this.scheduleNextFrame(state);
      }

      scheduleNextFrame(state) {
        if (!this.isStudioCurrent(state) || !state.running) return;
        state.timer = state.view.setTimeout(() => {
          state.timer = null;
          if (!this.isStudioCurrent(state) || !state.running) return;
          const index = state.frames.findIndex(frame => frame.dataset.studioFrame === this.studioSelection);
          const next = state.frames[(index + 1) % state.frames.length];
          this.setFrame(state, next.dataset.studioFrame);
          this.scheduleNextFrame(state);
        }, 3200);
      }

      stopPlayback(state) {
        if (state.timer !== null) state.view.clearTimeout(state.timer);
        state.timer = null;
        state.running = false;
      }

      setFrame(state, name, instant = false) {
        if (!this.isStudioCurrent(state) || !state.frames.some(frame => frame.dataset.studioFrame === name)) return;
        this.classList.toggle('chsa--instant', instant || state.motion.matches);
        this.studioSelection = name;
        this.dataset.activeFrame = name;
        for (const frame of state.allFrames) {
          const active = frame.dataset.studioFrame === name;
          frame.classList.toggle('is-active', active);
          frame.setAttribute('aria-hidden', String(!active));
        }
        for (const choice of state.choices) choice.setAttribute('aria-pressed', String(choice.dataset.studioChoice === name));
      }

      /** @param {MouseEvent} event A native finish choice resets the automatic dwell. */
      selectFrame(event) {
        const state = this.studioState;
        const choice = event.target instanceof Element ? event.target.closest('[data-studio-choice]') : null;
        if (!state?.ready || !choice || !this.contains(choice) || choice.hidden) return;
        this.stopPlayback(state);
        this.setFrame(state, choice.dataset.studioChoice);
        this.maybePlay(state);
      }

      cleanupStudio() {
        const state = this.studioState;
        this.studioState = null;
        if (!state) return;
        state.observer?.disconnect();
        state.controller.abort();
        this.stopPlayback(state);
        if (state.legacyMotionListener) state.motion.removeListener(state.legacyMotionListener);
        if (state.controls) state.controls.hidden = true;
      }
    }

    customElements.define('cavador-home-studio', CavadorHomeStudio);
  }).catch(() => {});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (function () {
    function collectionDestination(value) {
      try {
        if (!value) return null;
        const url = new URL(value, window.location.origin);
        if (url.origin !== window.location.origin || url.username || url.password) return null;
        if (!/^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/collections\/[^/]+\/?$/i.test(url.pathname)) return null;
        url.hash = '';
        return url.pathname + url.search;
      } catch { return null; }
    }
    function updateContinueLinks() {
      let destination;
      try { destination = collectionDestination(sessionStorage.getItem('cavador:browse-collection')); } catch { return; }
      if (!destination) return;
      document.querySelectorAll('[data-cavador-continue]').forEach(link => link.setAttribute('href', destination));
    }
    updateContinueLinks();
    window.addEventListener('pageshow', updateContinueLinks);
    document.addEventListener('shopify:cart:lines-update', event => {
      if (event.promise?.then) event.promise.then(updateContinueLinks).catch(() => {});
    });
    document.addEventListener('click', event => {
      if (event.target instanceof Element && event.target.closest('[data-cavador-continue]')) updateContinueLinks();
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
